import { useMemo } from 'react';
import type { CommonFolderTreeProps, FolderDTO } from './types';
import { getFolderStructure } from './helpers';
import { TreeFolder } from './components/TreeFolder';
import { getKDSClasses } from '../util';

export type { RenderTrailingProps, FolderStruct } from './types';

export const FoldersTree = <T,>({
  rootFolder,
  folders,
  selectedFolderId = null,
  onChangeSelected,
  expandedFolderIds = null,
  onChangeExpanded,
  renderTrailing,
  maxWidth,
}: {
  rootFolder: FolderDTO<T>;
  folders: FolderDTO<T>[];
} & CommonFolderTreeProps<T>) => {
  const folderStructure = useMemo(
    () => getFolderStructure(folders, rootFolder),
    [folders, rootFolder]
  );

  return (
    <div className={getKDSClasses('folders-tree')}>
      <TreeFolder
        folderStructure={folderStructure}
        selectedFolderId={selectedFolderId}
        onChangeSelected={onChangeSelected}
        expandedFolderIds={expandedFolderIds}
        onChangeExpanded={onChangeExpanded}
        renderTrailing={renderTrailing}
        maxWidth={maxWidth}
      />
    </div>
  );
};
